import { render, staticRenderFns } from "./modifyRestock.vue?vue&type=template&id=83504ae2&scoped=true&"
import script from "./modifyRestock.vue?vue&type=script&lang=js&"
export * from "./modifyRestock.vue?vue&type=script&lang=js&"
import style0 from "./modifyRestock.vue?vue&type=style&index=0&id=83504ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83504ae2",
  null
  
)

export default component.exports